import { Text, Image, Carousel, Button } from '@belong/ui';
import { useStore } from 'src/store';
import { pushModalSelector } from 'src/store/modal';
import { GET_STARTED_STRINGS } from '../get-started.strings';

const BENEFITS_ITEMS = [
  {
    icon: 'residents/benefits/support-chat.png',
    body: GET_STARTED_STRINGS.benefits.stress_free,
  },
  {
    icon: 'residents/benefits/belong-medal.png',
    body: GET_STARTED_STRINGS.benefits.standards,
  },
  {
    icon: 'residents/benefits/belong_app.png',
    body: GET_STARTED_STRINGS.benefits.belong_app,
  },
];

function BenefitsCarrousel() {
  const pushModal = useStore(pushModalSelector);

  function handleLearnMoreClick() {
    pushModal({ type: 'BELONG_STANDARDS' });
  }
  return (
    <div className="contents md:hidden">
      <Carousel>
        {BENEFITS_ITEMS.map((item, index) => (
          <div
            className="mr-lg flex min-w-full justify-center last:mr-0"
            key={index}
          >
            <div
              className=" p-sm flex h-[330px] flex-col items-center"
              key={index}
            >
              <div className="mb-lg h-[180px]">
                <Image
                  src={item.icon}
                  alt=""
                  className="h-full w-auto object-contain"
                />
              </div>
              <Text variant="body" className="leading-p1 text-center">
                {item.body}
              </Text>
              {index === 1 && (
                <Button
                  variant="text"
                  onClick={handleLearnMoreClick}
                  className="mt-sm"
                >
                  Learn More
                </Button>
              )}
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export function Benefits({ className }: { className?: string }) {
  const pushModal = useStore(pushModalSelector);

  function handleLearnMoreClick() {
    pushModal({ type: 'BELONG_STANDARDS' });
  }

  return (
    <div className={className}>
      <Text variant="h2" fontWeight="semibold" className="mb-xl text-center">
        {GET_STARTED_STRINGS.benefits.title}
      </Text>
      <BenefitsCarrousel />
      <div className="gap-sm hidden md:grid md:grid-cols-3">
        {BENEFITS_ITEMS.map((item, index) => (
          <div
            className="p-sm flex h-[330px] flex-col items-center"
            key={index}
          >
            <div className="mb-lg" style={{ height: 180 }}>
              <Image
                src={item.icon}
                alt=""
                className="h-full w-auto object-contain"
              />
            </div>
            <Text variant="body" className="leading-p1 text-center">
              {item.body}
            </Text>
            {index === 1 && (
              <Button
                variant="text"
                onClick={handleLearnMoreClick}
                className="mt-sm"
              >
                Learn More
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
